module.exports = __webpack_public_path__ + "media/images/svgs/agrokomplex-ef1c973c7b672610d11dd4db7520c697.svg";